import React from 'react';
import Button from './Button';
import addUnsavedChangesWarnPreAction from '../hoc/addUnsavedChangesWarn';
import { goToHome } from '../../redux/actions';
import HomeIcon from '../../assets/images/home.svg';

const HomeButton = ({
  className = 'home-btn',
  onClick,
}) => (
  <Button
    title="Home"
    onClick={onClick}
    className={className}
  >
    <img src={HomeIcon} className="home-icon-img" alt="" />
  </Button>
);

export default addUnsavedChangesWarnPreAction(HomeButton, goToHome);
